import { render, staticRenderFns } from "./BCGovHeader.vue?vue&type=template&id=69b52fa0&scoped=true"
import script from "./BCGovHeader.vue?vue&type=script&lang=js"
export * from "./BCGovHeader.vue?vue&type=script&lang=js"
import style0 from "./BCGovHeader.vue?vue&type=style&index=0&id=69b52fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b52fa0",
  null
  
)

export default component.exports